export default "__VITE_ASSET__CIL6r7ZQ__"